import { axiosInstance } from "./BaseService" 

export async function getProducts(storeId) {
  try {
    const response = await axiosInstance.get('/products', {
      params: storeId ? { storeId } : undefined,
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function defineGroupFilterAndDriversOptions() {
  try {
    const response = await axiosInstance.get('/products/group-filters-and-drivers');
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function getAverageProductDrivers(productIds) {
  try {
    const response = await axiosInstance.get(`/products/average?productIds=${productIds}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}